
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.95 2c-1.24 0-2.297.766-2.688 1.835H7.025c-2.361 0-4.275 1.849-4.275 4.13 0 2.28 1.914 4.128 4.275 4.128h10.45c1.312 0 2.375 1.027 2.375 2.294 0 1.267-1.063 2.294-2.375 2.294h-2.932l1.229-1.186-1.344-1.298-3.522 3.402L14.428 21l1.344-1.298-1.229-1.186h2.932c2.361 0 4.275-1.849 4.275-4.129 0-2.28-1.914-4.129-4.275-4.129H7.025c-1.312 0-2.375-1.027-2.375-2.294 0-1.267 1.063-2.294 2.375-2.294h8.237c.391 1.07 1.447 1.835 2.688 1.835 1.574 0 2.85-1.232 2.85-2.752C20.8 3.233 19.524 2 17.95 2zm.95 2.752c0 .507-.425.918-.95.918-.525 0-.95-.41-.95-.918 0-.506.425-.917.95-.917.525 0 .95.41.95.917zM6.55 20.351c-1.574 0-2.85-1.232-2.85-2.753 0-1.52 1.276-2.752 2.85-2.752s2.85 1.232 2.85 2.752c0 1.52-1.276 2.753-2.85 2.753zm.95-2.753c0 .507-.425.917-.95.917-.525 0-.95-.41-.95-.917 0-.507.425-.918.95-.918.525 0 .95.41.95.918z"}})])
          )
        }
      }
    